'use strict';

var chunkJHFKSNYO_js = require('./chunk-JHFKSNYO.js');

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function t(e){let r=typeof e;if(e==="undefined"||e===null||r==="string"||r==="boolean"||r==="number")return !0;if(r.includes("function"))return !1;if(Array.isArray(e)){if(e.some(n=>!t(n)))return !1}else if(chunkJHFKSNYO_js.a(e)&&Object.values(e).some(n=>!t(n)))return !1;return !0}

exports.a = t;
